import React, {memo} from 'react';
import {styles} from "./index";
import Space, {spaceSizes} from "@/app/components/Space";
import classNames from "classnames";

interface RadioItemProps {
  items: RadioItems
  setSelectedItem: (item: RadioItem) => void,
  selectedItem: RadioItem | null
}

export interface RadioItems {
  items: RadioItem[]
}

export interface RadioItem {
  id: number
  title: string
  description: string
}

const RadioWidget: React.FC<RadioItemProps> = ({items, setSelectedItem, selectedItem}) => {
  return (<div className={styles.items}>
    {items.items.map((item) => (<div
      key={item.id}
      className={classNames(styles.card, {[styles.isSelected]: selectedItem?.id === item.id})}
      onClick={() => setSelectedItem(item)}
    >
      <div className={classNames(styles.radio, {[styles.isSelected]: selectedItem?.id === item.id})}>
        <div className={styles.radio_inner}/>
      </div>
      <div className={styles.content}>
        <span className={styles.title}>{item.title}</span>
        <span className={styles.description}>{item.description}</span>
      </div>
    </div>))}
  </div>);
}

export default memo(RadioWidget);